import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Blogs from './components/Blogs';
import Podcasts from './components/Podcasts';
import Events from './components/Events';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Hero />
      <About />
      <Experience />
      <Blogs />
      <Podcasts />
      <Events />
      <Projects />
      <Skills />
      <Contact />
      <Footer />
      <Chatbot />
    </div>
  );
}

export default App;
